export class StickyHeader {
    constructor() {
        this.header = document.querySelector('.header');
        this.headerOffsetTop = this.header.offsetTop;
        this.makeHeaderSticky = this.makeHeaderSticky.bind(this);
    }

    makeHeaderSticky() {
        if (window.pageYOffset >= this.headerOffsetTop) {
            this.header.classList.add('sticky');
        } else {
            this.header.classList.remove('sticky');
        }
    }

    init() {
        window.addEventListener('scroll', this.makeHeaderSticky);
    }
}
